import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { REST_BASE_URL } from '../app.config';
import { VisumAntragsartEnum } from '../components/config/config-mek-d-visum';
import { AppService } from './app.service';
import { validatedInput } from './validators';

@Injectable({ providedIn: 'root' })
export class ValidationService {

  protected validationMetadata$: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(private http: HttpClient, protected appService: AppService) { }

  fetchValidationMetadata(): Observable<any> {

    const params = new HttpParams()
      .set('visumAntragsartEnum', this.appService.isCVisumWindow() ? VisumAntragsartEnum.KURZFRISTIGER_AUFENTHALT : VisumAntragsartEnum.LANGFRISTIGER_AUFENTHALT);

    return this.http
      .get<any>(REST_BASE_URL + '/visum-antrag/validation-metadata', {params}).pipe(
      tap((result) => {
        this.validationMetadata$.next(result);
      }));
  }

  getValidationMetadata$() {
    return this.validationMetadata$.asObservable();
  }

  getProperties(path: string) {
    if (!this.validationMetadata$.value) {
      return null;
    }
    return path.split(".").reduce((object, path) => object[path], this.validationMetadata$.value);
  }

  // TODO: ein Enumeration-Eintrag verwenden statt einzelne exclusive booleans
  getValidators(formFieldName: string, isDatepickerField?: boolean, isEmailField?: boolean, isListField?: boolean): ValidatorFn[] {
    const validatorConfig = (this.validationMetadata$.value ?? {})[formFieldName];
    let validators: ValidatorFn[] = [];

    if (validatorConfig) { // catch if no definition (expl. geburtsdatum vater)
      if (isDatepickerField || isListField) {
        validators = validatedInput(validatorConfig.mandatory, null, null, null, null, null);
      } else {
        validators = validatedInput(validatorConfig.mandatory, validatorConfig.minLength, validatorConfig.maxLength, validatorConfig.minValue, validatorConfig.maxValue, validatorConfig.maskRegex);
      }
    } else {
      validators = validatedInput(false, null, null, null, null, null);
    }

    // Diese Stelle ist auskommentiert, da die Anträge aus der ExtJS-Anwendung u.U. E-Mail
    // Adressen haben, die diese Validierung bemängelt. Diese Stelle soll wieder aktiviert werden,
    // sobald es absehbar ist, dass keine Anträge mehr aus der ExtJS-Anwendung importiert werden.
    // if(isEmailField) {
    //   validators.push(this.emailOrEmpty);
    // }

    return validators;
  }

  emailOrEmpty(control: AbstractControl): ValidationErrors | null {
    if (control.value) {
      return Validators.email(control);
    } else {
      return null;
    }
  }

  /**
   * Gibt alle durch das Backend bereitgestellte Validatoren und zusätzlich den Validators.required zurück, unabhängig davon, ob Backend
   * diesn Validator bereitstellt oder nicht.
   */
  public getValidatorsAndRequired(formFieldName: string, isDatepickerField?: boolean, isEmailField?: boolean): ValidatorFn[] {
    const ret = this.getValidators(formFieldName, isDatepickerField, isEmailField);
    ret.push(Validators.required);
    return ret;
  }

  public makeRequired(control: AbstractControl) {
    if (this.controlNotFound(control)) {
      return;
    }
    control.addValidators(Validators.required);
    control.updateValueAndValidity({ emitEvent: true });
  }

  public makeNotRequired(control: AbstractControl) {
    if (this.controlNotFound(control)) {
      return;
    }
    control.removeValidators(Validators.required);
    control.updateValueAndValidity({ emitEvent: true });
  }

  private controlNotFound(control: AbstractControl) {
    if (!control) {
      console.warn(`Control not found.`);
      return true;
    }
    return false;
  }
}
